import toJSON from '@/shared/utils/plugins/toJSON/toJSON.js';

export { toJSON };
